module.exports = __webpack_public_path__ + "static/og-36e92f76273950d0ce779297f12ee0e4.png";